import api from '../..'

const setActiveBulkAction = (
  userIds: number[],
  lms_active: boolean,
  search: string,
  allSelected: boolean,
  unselectedRows: number[]
) => {
  return api.post(`administration/multiple_users`, {
    multiples: {
      userIds,
      lms_active,
      search,
      allSelected,
      unselectedRows
    }
  })
}

export default setActiveBulkAction
